export const HEALTH_BENEFITS_APPROVE_RATE = [
  {
    value: 33.33,
    label: '33.33% (1 month)',
  },
  {
    value: 66.67,
    label: '66.67% (2 months)',
  },
  {
    value: 100,
    label: '100% (3 months)',
  },
];
